import title from 'text!./templates/Title.html';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: title,
        scope: {},
        link: function link($scope, $element, $attrs) {
            if ('offset' in $attrs) {
                $scope.hasOffset = true;
            }
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/titles/Title.js
// module id = 1177
// module chunks = 0